// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voice-controls {
  padding: 16px;
  border-top: 1px solid #e0e0e0;
  background-color: #f9f9f9;
}

.voice-mode-selector {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.mode-button {
  flex: 1;
  padding: 8px 16px;
  border: 1px solid #ddd;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.mode-button:hover {
  background-color: #f0f0f0;
}

.mode-button.active {
  background-color: #0066cc;
  color: white;
  border-color: #0066cc;
}

.voice-controls-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.control-button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
  transition: background-color 0.2s;
}

.control-button:hover {
  background-color: #f0f0f0;
}

.control-button.muted {
  background-color: #ffebee;
  border-color: #f44336;
}

.volume-control {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.volume-slider {
  flex: 1;
  height: 4px;
  border-radius: 2px;
  background: #ddd;
  outline: none;
}

.volume-slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #0066cc;
  cursor: pointer;
}

.volume-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #0066cc;
  cursor: pointer;
  border: none;
}

.volume-value {
  font-size: 12px;
  color: #666;
  min-width: 40px;
  text-align: right;
}

.listening-indicator {
  font-size: 14px;
  color: #1976d2;
  font-weight: 500;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

`, "",{"version":3,"sources":["webpack://./src/components/VoiceControls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".voice-controls {\n  padding: 16px;\n  border-top: 1px solid #e0e0e0;\n  background-color: #f9f9f9;\n}\n\n.voice-mode-selector {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.mode-button {\n  flex: 1;\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.mode-button:hover {\n  background-color: #f0f0f0;\n}\n\n.mode-button.active {\n  background-color: #0066cc;\n  color: white;\n  border-color: #0066cc;\n}\n\n.voice-controls-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.control-button {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 18px;\n  transition: background-color 0.2s;\n}\n\n.control-button:hover {\n  background-color: #f0f0f0;\n}\n\n.control-button.muted {\n  background-color: #ffebee;\n  border-color: #f44336;\n}\n\n.volume-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.volume-slider {\n  flex: 1;\n  height: 4px;\n  border-radius: 2px;\n  background: #ddd;\n  outline: none;\n}\n\n.volume-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #0066cc;\n  cursor: pointer;\n}\n\n.volume-slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #0066cc;\n  cursor: pointer;\n  border: none;\n}\n\n.volume-value {\n  font-size: 12px;\n  color: #666;\n  min-width: 40px;\n  text-align: right;\n}\n\n.listening-indicator {\n  font-size: 14px;\n  color: #1976d2;\n  font-weight: 500;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
